import gql from 'graphql-tag'

export const NOTIFY_CLICK = gql`
  mutation NotifyClick($ticket: String!) {
    notifyClick(ticket: $ticket)
  }
`
